@if (contact) {
    <section class="mobi-ui-section-minor mobi-ui-ink-grey">
        <div
            class="mobi-ui-container"
            [className]="contact.person ? 'osm-contact-person' : 'osm-contact-organisation'"
        >
            <mobi-ui-contact-person-major
                [mapLocations]="[
                    {
                        lat: contact.organisationUnit?.geoLocation?.lat,
                        lng: contact.organisationUnit?.geoLocation?.lng,
                    },
                ]"
                [imgSrc]="contact.person?.images?.xxs || contact.organisationUnit?.images?.xxs"
                [iconName]="
                    contact.person?.images?.xxs || contact.organisationUnit?.images?.xxs
                        ? undefined
                        : contact.person
                          ? 'face'
                          : 'office_building'
                "
            >
                <span class="mobi-ui-font-h6">{{
                    (contact.person
                        ? 'osm.footer.gainfo.ansprechperson.title'
                        : 'osm.footer.gainfo.ansprechpartner.title'
                    ) | translate
                }}</span>
                <span class="mobi-ui-font-h3 mobi-ui-padding-none">{{
                    contact.person?.name || contact.organisationUnit?.names?.name || ''
                }}</span>
                @if (contact.person?.jobTitles?.jobTitle) {
                    <span class="mobi-ui-font-tisa mobi-ui-font-italic">
                        {{ contact.person?.jobTitles?.jobTitle }} -
                        {{ contact.organisationUnit?.names?.name || '' }}
                    </span>
                }
                @if (!contact.person) {
                    <span class="mobi-ui-font-tisa mobi-ui-font-italic">
                        {{ 'osm.footer.gainfo.ihregeneralagentur.title' | translate }}
                    </span>
                }
                <div class="mobi-ui-card-minor mobi-ui-margin-t-md">
                    <div class="mobi-ui-text-block-major is-small">
                        <mobi-ui-icon-major name="house" class="md"></mobi-ui-icon-major>
                        <div class="mobi-ui-text-block-content-major">
                            <span class="mobi-ui-text-block-label-major">
                                {{ 'osm.footer.gainfo.card.address.label' | translate }}
                            </span>
                            <span class="mobi-ui-text-block-content">
                                {{ contact.organisationUnit?.addresses?.address?.street || '' }}
                            </span>
                            <span class="mobi-ui-text-block-content-major">
                                {{ contact.organisationUnit?.addresses?.address?.postalCode || '' }}
                                {{ contact.organisationUnit?.addresses?.address?.location || '' }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mobi-ui-card-minor">
                    <div class="mobi-ui-text-block-major is-small">
                        <mobi-ui-icon-major name="phone" class="md"></mobi-ui-icon-major>
                        <div class="mobi-ui-text-block-content-major">
                            <span class="mobi-ui-text-block-label-major">
                                {{ 'osm.footer.gainfo.card.phone.label' | translate }}
                            </span>
                            <span class="mobi-ui-text-block-content-major">
                                {{ contact.organisationUnit?.phone }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mobi-ui-margin-b-none mobi-ui-text-left link-wrapper">
                    @if (contact.organisationUnit?.webpages?.webpage) {
                        <a
                            class="mobi-ui-link-block-major"
                            [href]="'https://' + contact.organisationUnit?.webpages?.webpage"
                            target="_blank"
                        >
                            <mobi-ui-icon-major
                                class="mobi-ui-link-block-icon-major"
                                name="right"
                            ></mobi-ui-icon-major>
                            <span class="mobi-ui-link-block-text-major"
                                >{{ 'osm.footer.concierge.card.homepage.label' | translate }}
                            </span>
                        </a>
                    }
                </div>
            </mobi-ui-contact-person-major>
        </div>
    </section>
}
